// @need-translate
import {RefObject} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {useAdjustXAxisScrollPosition} from '../../../common/shared/hooks/useAdjustXAsixScrollPosition';
import {twMerge} from '../../../common/twMerge';
import {SHORTCUT_ICON_MAP} from '../../../domain/menu/constant';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {Text} from '../../atoms/Text/Text';
import {ScrollableHorizontalList} from '../../molecules/ScrollableHorizontalList/ScrollableHorizontalList';
import {TasteTabProps} from './TasteTabProps.interface';

export function TasteTab({
  className,
  tabItems,
  currentTabItemParam,
  isMobile,
  onClickTab,
  hasBottomLine,
  ...props
}: TasteTabProps) {
  const {tabRef, onSelectTabItem} = useAdjustXAxisScrollPosition(
    tabItems.findIndex(item => item.param === currentTabItemParam)
  );

  if (!tabItems || tabItems.length === 0) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'relative flex w-full flex-row items-center bg-theme-bg-base',
        hasBottomLine && 'border-b-1 border-theme-transparent-20',
        className
      )}
      {...putTiaraObjectProps({
        click: {
          layer1: '서브탭',
        },
        customProps: {
          subtab_list: tabItems.reduce((acc, cur) => {
            if (acc) {
              acc += ',';
            }
            acc += cur.param;
            return acc;
          }, ''),
        },
      })}
      {...props}
    >
      <ScrollableHorizontalList
        hideArrow
        isMobile={isMobile}
        ref={tabRef as RefObject<HTMLUListElement>}
        gapPx={6}
        innerLeftPx={10}
        innerRightPx={10}
        className="overflow-hidden"
        listItemClassName="shrink-0"
      >
        {tabItems.map((tabItem, idx) => {
          const isActive = currentTabItemParam === tabItem.param;
          return (
            <UrlLink key={tabItem.param} url={tabItem.href}>
              <div
                className={twMerge(
                  'flex h-36pxr w-full cursor-pointer select-none items-center rounded-100pxr px-14pxr text-theme-solid-0 mt-6pxr mb-14pxr',
                  isActive
                    ? 'bg-theme-solid-100 text-theme-solid-0'
                    : 'border-1 border-theme-transparent-20 bg-transparent text-theme-solid-100',
                  isActive && tabItem.icon && 'pl-6pxr pr-14pxr',
                  className
                )}
                onClick={e => {
                  onClickTab(tabItem.param, e);
                  onSelectTabItem(e.target as HTMLElement);
                }}
                {...putTiaraObjectProps({
                  click: {
                    ordnum: String(idx + 1),
                    copy: tabItem.name,
                  },
                })}
              >
                {isActive && tabItem.icon && (
                  <StaticImage
                    imageType={SHORTCUT_ICON_MAP[tabItem.icon]}
                    className="h-32pxr w-32pxr"
                    aria-hidden={true}
                  />
                )}
                <Text
                  className={twMerge(
                    'inline-block',
                    isActive ? 'font-small1-bold' : 'font-small1'
                  )}
                >
                  {isActive && <Text className="blind">선택됨, </Text>}
                  {tabItem.name}
                  <Text className="blind">
                    {' '}
                    탭, {`총 ${tabItems.length}개 중 ${idx + 1}번째`}
                  </Text>
                </Text>
              </div>
            </UrlLink>
          );
        })}
      </ScrollableHorizontalList>
    </div>
  );
}
